import React from "react";

const CardBackground = ({ children }) => {
  return (
    <div
      className="flex flex-row p-5 m-1 space-y-10 bg-white rounded-md shadow md:flex-row md:space-y-0 md:m-1"
      style={{ wordBreak: "break-word" }}
    >
      {children}
    </div>
  );
};

export default CardBackground;
